
/* eslint vue/no-unused-components: 0 */
import { mapState } from 'vuex';
import formMixin from '~/services/form';
import { email, required } from '~/services/validators';
import IconEnvelope from '~/components/icon/IconEnvelope.vue';
import IconMapMarkerAlt from '~/components/icon/IconMapMarkerAlt.vue';

export default {
    name: 'Contact',
    mixins: [formMixin],
    data() {
        return {
            enquiryTypeOptions: [
                { slug: 'business', name: this.$t('contact.business') },
                { slug: 'council', name: this.$t('contact.council') },
                { slug: 'general', name: this.$t('contact.general') },
                { slug: 'media', name: this.$t('contact.media') },
                { slug: 'support', name: this.$t('contact.support') },
            ],
            items: [
                {
                    icon: IconMapMarkerAlt,
                    html: `<address>${this.$config.contact.addressLine1}<br>${this.$config.contact.addressLine2}<br>${this.$config.contact.city}<br>
                            ${this.$config.contact.county}<br>${this.$config.contact.postcode}<br></address>`,
                },
                {
                    icon: IconEnvelope,
                    html: `<a href="mailto:${this.$config.contact.email}">${this.$config.contact.email}</a>`,
                },
            ],
            email: '',
            message: '',
            name: '',
            enquiryType: this.$route.query.type,
        };
    },
    computed: {
        ...mapState(['isMobile']),
        pressText() {
            return this.$t('contact.visit_press_page').split(new RegExp(/<a>([\w\s]+)<\/a>/));
        },
    },
    methods: {
        async submit() {
            const { message } = await this.$form.submit(`${this.$config.endpoints.contact}`, '$post', {
                email: this.email,
                enquiry_type: this.enquiryType,
                message: this.message,
                name: this.name,
            });
            this.$store.dispatch('setFlashMessage', { message });
            this.email = '';
            this.enquiryType = '';
            this.message = '';
            this.name = '';
            this.$form.reset();
        },
    },
    validations: {
        email: [email, required],
        message: [required],
        name: [required],
        enquiryType: [required],
    },
};
